module.exports = __webpack_public_path__ + "static/media/popover_input.f94a5669.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/popover_input.png
// module id = 1846
// module chunks = 0 1